import { StudentLayout } from '@/components/layout/student'
import { StudentRequestContent } from '@/components/layout/student/request-content'
import { ExternalTransferPreviousEducationData } from '@/components/student/transfer-steps/step-1/external-transfer-previous-education-data'
import { CheckTheEquivalences } from '@/components/student/transfer-steps/step-2/check-the-equivalences'
import { StudentTransferDesiredCourseStep } from '@/components/student/transfer-steps/step-3'
import { useStudentChangeOfMajorForm } from './hooks/use-student-change-of-major-form'
import { useSubmitStudentChangeOfMajor } from './hooks/use-submit-student-change-of-major'

export const StudentChangeOfMajorPage = () => {
  const {
    states: { formMethods, formMethodsIA }
  } = useStudentChangeOfMajorForm()

  const {
    states: {
      currentStep,
      fileStatus,
      isPreviousEducationSavePending,
      isCourseEquivalencePending,
      isCourseEquivalenceSuccess,
      isPendingDesiredEducation,
      request,
      isPendingEquivalences,
      fileWarning,
      disabledButtons
    },
    actions: { handleBack, handleNext, uploadMutate }
  } = useSubmitStudentChangeOfMajor(formMethods, formMethodsIA)

  const requestLabel = 'Troca de Curso'

  const steps = [
    {
      label: 'Curso Anterior',
      content: (
        <ExternalTransferPreviousEducationData
          requestLabel={requestLabel}
          fileStatus={fileStatus}
          formMethods={formMethods}
          uploadMutation={uploadMutate}
          request={request}
          fileWarning={fileWarning}
        />
      ),
      pendingSave: isPreviousEducationSavePending
    },
    {
      label: 'Curso para a troca',
      content: (
        <StudentTransferDesiredCourseStep control={formMethods.control} />
      ),
      pendingSave: isPendingDesiredEducation
    },
    {
      label: 'Disciplinas a Dispensar',
      content: (
        <CheckTheEquivalences
          formMethods={formMethods}
          formMethodsAI={formMethodsIA}
          isPendingEquivalenceGenerate={isPendingEquivalences}
          isPendingSubmit={isCourseEquivalencePending}
          fileStatus={fileStatus}
          isSuccessSubmit={isCourseEquivalenceSuccess}
          request={request}
        />
      ),
      pendingSave: isCourseEquivalencePending
    }
  ]

  return (
    <StudentLayout>
      <StudentRequestContent
        requestTitle={requestLabel}
        steps={steps}
        currentStep={currentStep}
        handleNext={handleNext}
        fileStatus={fileStatus}
        handleBack={handleBack}
        request={request}
        disabledButtons={disabledButtons}
        finishedTransfer={isCourseEquivalenceSuccess}
      />
    </StudentLayout>
  )
}
